// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Motion$LiteracyplanetTupperware from "./Motion.res.mjs";
import * as StopIcon$LiteracyplanetTupperware from "../v2/StopIcon.res.mjs";
import * as VolumeIcon$LiteracyplanetTupperware from "../v2/VolumeIcon.res.mjs";
import * as SpinnerIcon$LiteracyplanetTupperware from "../v2/SpinnerIcon.res.mjs";
import * as V3RefManager$LiteracyplanetTupperware from "./V3RefManager.res.mjs";
import * as StimulusToggleContext$LiteracyplanetTupperware from "../v2/StimulusToggleContext.res.mjs";
import * as V3AudioEmbeddedComponent$LiteracyplanetTupperware from "./V3AudioEmbeddedComponent.res.mjs";

function V3StimulusWithImageAndAudio(props) {
  var sources = props.sources;
  var match = Curry._1(StimulusToggleContext$LiteracyplanetTupperware.useState, undefined);
  var onToggleStimulus = match[1];
  return React.createElement(React.Fragment, {}, React.createElement("div", {
                  className: "image-place relative"
                }, sources !== undefined ? React.createElement(V3AudioEmbeddedComponent$LiteracyplanetTupperware.V3AudioEmbeddedComponent.make, {
                        audioId: "stimulusWithImageAndAudio",
                        sources: sources,
                        autoPlay: false,
                        children: (function (state) {
                            var tmp;
                            switch (state) {
                              case "Loading" :
                                  tmp = React.createElement(SpinnerIcon$LiteracyplanetTupperware.make, {
                                        className: "w-8 h-8 fill-black"
                                      });
                                  break;
                              case "Stopped" :
                                  tmp = React.createElement(VolumeIcon$LiteracyplanetTupperware.make, {
                                        className: "w-8 h-8 fill-black"
                                      });
                                  break;
                              case "Playing" :
                                  tmp = React.createElement(StopIcon$LiteracyplanetTupperware.make, {
                                        className: "w-8 h-8 fill-black"
                                      });
                                  break;
                              
                            }
                            return React.createElement("button", {
                                        className: "stimulus-play-audio-button"
                                      }, tmp);
                          })
                      }) : null, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                      id: "stimulusImage",
                      className: "pilot-stimulus-image",
                      children: null
                    })), React.createElement(V3RefManager$LiteracyplanetTupperware.PortalImmediate.make, {
                  id: "showTutorialText",
                  children: React.createElement(Motion$LiteracyplanetTupperware.Div.make, {
                        initial: {
                          transform: "translateY(-100%)"
                        },
                        animate: {
                          transform: "translateY(0px)"
                        },
                        transition: {
                          type: "spring",
                          duration: 1
                        },
                        className: match[0] ? "invisible" : "",
                        children: Caml_option.some(React.createElement("button", {
                                  className: "pilot-lesson-button",
                                  onClick: (function (evt) {
                                      Curry._1(onToggleStimulus, undefined);
                                      evt.stopPropagation();
                                    })
                                }, "Text"))
                      })
                }), props.children);
}

var make = V3StimulusWithImageAndAudio;

export {
  make ,
}
/* react Not a pure module */
